import React from 'react';
import {styled} from '@mui/material';
import {Body, Button, Icon, Tooltip} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './RecruitCrmActionsBar.module.scss';

type RecruitCrmActionsBarProps = {
  selectedCount: number;
  onMessageCreators: () => void;
  onRequestVetting: () => void;
  showRequestVetting: boolean;
  onBulkRemove: () => void;
  onClearSelection: () => void;
};

const ActionsContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
});

function RecruitCrmActionsBar({
  selectedCount,
  onMessageCreators,
  onRequestVetting,
  showRequestVetting,
  onBulkRemove,
  onClearSelection,
}: RecruitCrmActionsBarProps) {
  return (
    <>
      <Body size="md">
        {translate('creators selected', {count: selectedCount})}
      </Body>
      <ActionsContainer>
        <Tooltip
          type="dark"
          title={translate('Message creators', {count: selectedCount})}
          placement="top"
          arrow
        >
          <span>
            <Button
              size="medium"
              appearance="neutral"
              mode="plain"
              onClick={onMessageCreators}
              icon={
                <Icon
                  size="medium"
                  appearance="neutral"
                  name="Navigation-Mail"
                />
              }
            />
          </span>
        </Tooltip>
        {showRequestVetting && (
          <Tooltip
            type="dark"
            title={translate('Request Vetting')}
            placement="top"
            arrow
          >
            <span>
              <Button
                size="medium"
                appearance="neutral"
                mode="plain"
                onClick={onRequestVetting}
                icon={
                  <Icon
                    size="medium"
                    appearance="neutral"
                    name="Navigation-Shopbag-Shield-Stroke"
                  />
                }
              />
            </span>
          </Tooltip>
        )}
        <Tooltip type="dark" title={translate('Remove')} placement="top" arrow>
          <span>
            <Button
              size="medium"
              appearance="neutral"
              mode="plain"
              onClick={onBulkRemove}
              icon={
                <Icon
                  size="medium"
                  appearance="neutral"
                  name="Actions-Remove"
                />
              }
            />
          </span>
        </Tooltip>
      </ActionsContainer>
      <Button
        mode="plain"
        appearance="neutral"
        size="medium"
        onClick={onClearSelection}
        className={styles.clearButton}
      >
        {translate('Clear selection')}
      </Button>
    </>
  );
}

export default RecruitCrmActionsBar;
